import React from "react";

const NotFoundPage = () => {
  return (
    <div style={{ height: "100%", width: "100%" }}>
      <h1>Not Found Page</h1>
    </div>
  );
};

export default NotFoundPage;
